import { useOutletContext, useParams } from 'react-router-dom';
import { useGetCarsByDealerQuery } from '../../../services/carService/__generated__/queries.generated';
import { MoonLoader } from 'react-spinners';
import styled from 'styled-components';
import CarCard from '../../../components/car/CarCard';
import { useState } from 'react';
import { IGetCarsByDealerQuery } from '../../../services/carService/__generated__/queries.generated';
import tw from 'twin.macro';
import { useSnapshot } from 'valtio';
import { dealerStore } from '../../../../store/dealerStore';

// Styled components matching the landing page style
const PageContainer = styled.div`
  ${tw`
    w-full
    max-w-full
    min-w-0
    flex
    flex-col
    items-center
    bg-gray-900
    text-white
    min-h-screen
    py-12
    pb-8
    md:pb-16
    box-border
  `}
`;

const ContentContainer = styled.div`
  ${tw`
    w-full
    max-w-full
    min-w-0
    max-w-screen-xl
    mx-auto
    px-4
    box-border
  `}
`;

const SectionTitle = styled.h2`
  ${tw`
    text-3xl
    font-bold
    text-center
    mb-12
    text-white
  `}
`;

const CarGrid = styled.div`
  ${tw`
    grid
    grid-cols-1
    md:grid-cols-2
    lg:grid-cols-3
    gap-8
  `}
`;

const LoadingContainer = styled.div`
  ${tw`
    flex
    justify-center
    items-center
    h-screen
    bg-gray-900
  `}
`;

const EmptyState = styled.div`
  ${tw`
    text-center
    py-12
    text-gray-400
    text-xl
 w-full max-w-full min-w-0 box-border`}
`;

function CarListPage() {
  // Use dealer ID from the store instead of outlet context
  const { dealerId } = useSnapshot(dealerStore);

  const [carBeingViewed, setCarBeingViewed] = useState<
    IGetCarsByDealerQuery['getAllCarsOnSaleByDealer'][0] | null
  >(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, error, loading } = useGetCarsByDealerQuery({
    variables: {
      input: {
        dealerId: dealerId ?? '',
      },
    },
    skip: !dealerId,
  });

  const handleCardClick = (car: IGetCarsByDealerQuery['getAllCarsOnSaleByDealer'][0]) => {
    setCarBeingViewed(car);
    setIsModalOpen(true);
  };

  if (loading) {
    return (
      <LoadingContainer>
        <MoonLoader color="#f56565" />
      </LoadingContainer>
    );
  }

  // Use API data
  const cars = data?.getAllCarsOnSaleByDealer;

  if (!cars || cars?.length === 0) {
    return (
      <PageContainer>
        <ContentContainer>
          <EmptyState>No cars found</EmptyState>
        </ContentContainer>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <ContentContainer>
        <SectionTitle>Cars on Sale</SectionTitle>
        <CarGrid>
          {cars.map(car => {
            if (!car.name || !car.year || !car.make || !car.model || !car.thumbnailUrl) {
              return null;
            }
            return (
              <CarCard
                key={car.id}
                {...car}
                onDetailClicked={() => handleCardClick(car)}
                onCardClicked={() => handleCardClick(car)}
              />
            );
          })}
        </CarGrid>
      </ContentContainer>
    </PageContainer>
  );
}

export default CarListPage;
